export default {"src":"/_next/static/media/roadmap.4d61b1dd.svg","height":2500,"width":3415,"blurWidth":0,"blurHeight":0};